export const PAGE_SIZE = 25;

export const WYSIWYG_EDITOR_CONFIG = [
    [{ 'header': [] }],
    [{ 'font': [] }],
    ['bold', 'italic', 'underline', 'strike', 'align', {'align': 'center'}, {'align': 'right'}, 'blockquote', 'link', 'image'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'indent': '-1'}, { 'indent': '+1' }],
    [{ 'direction': 'rtl' }],
    [{ 'color': [] }, 
    { 'background': [] }],
    ['clean']  
]